import logo from './logo.svg';
import React, { Component }  from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ThemeProvider from 'react-bootstrap/ThemeProvider'
import Layout from "../src/Page/layout/layout";
import './App.css';

import { BrowserRouter } from "react-router-dom";
function App() {
  return (
    <ThemeProvider
    breakpoints={['xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs']}
    minBreakpoint="xxs"
  >
    <BrowserRouter>
    <Layout />
    </BrowserRouter>

</ThemeProvider>
  );
}

export default App;
